// extracted by mini-css-extract-plugin
export var postCard = "Tile-module--post-card--WJT7g";
export var postCardContent = "Tile-module--post-card-content--0K-Uh";
export var postCardImage = "Tile-module--post-card-image--++07T";
export var postCardImageWrapper = "Tile-module--post-card-image-wrapper--+ApJH";
export var postCardInfo = "Tile-module--post-card-info--eZMZ3";
export var postCardTitle = "Tile-module--post-card-title---4aRk";
export var primary = "#06004d";
export var secondary = "#4dafd7";